export const aboutUsAltIcon = `
<svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9656 14.4736H5.7456M12.9656 10.2871H5.7456M8.5007 6.1103H5.7457M13.158 1C13.158 1 5.481 1.004 5.469 1.004C2.709 1.021 1 2.837 1 5.607V14.803C1 17.587 2.722 19.41 5.506 19.41C5.506 19.41 13.182 19.407 13.195 19.407C15.955 19.39 17.665 17.573 17.665 14.803V5.607C17.665 2.823 15.942 1 13.158 1Z" stroke="#00ABC7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
